import {GetBannerRequest_PriorityOverride} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/banner/service.types';

export const DISABLE_HEADER_HIGHLIGHT_PARAM = 'disableHeaderHighlight';
export const HEADER_HIGHLIGHT_OVERRIDE_PARAM = 'headerHighlightOverride';

// URL-facing override values from the Header Highlight tech concept, mapped to
// the BannerService `PriorityOverride` oneof. `retailMediaCampaign` and
// `onSiteCampaign` are their own override cases in the schema — they are NOT
// folded under `sponsoredContent`.
const OVERRIDE_BY_URL_VALUE: Record<string, GetBannerRequest_PriorityOverride> =
  {
    sponsoredcontent: {type: {$case: 'sponsoredContent', sponsoredContent: {}}},
    pxcampaign: {type: {$case: 'pxCampaign', pxCampaign: {}}},
    htcoupon: {type: {$case: 'htCouponBanner', htCouponBanner: {}}},
    nonpxcampaign: {type: {$case: 'nonPxCampaign', nonPxCampaign: {}}},
    retailmediacampaign: {
      type: {$case: 'retailMediaCampaign', retailMediaCampaign: {}},
    },
    onsitecampaign: {type: {$case: 'onSiteCampaign', onSiteCampaign: {}}},
  };

// Unrecognized values resolve to `undefined` so the request omits the override
// and the BE applies normal prioritization (its fallback only covers
// valid-but-unavailable types).
export const mapHeaderHighlightOverride = (
  value: string | null | undefined,
): GetBannerRequest_PriorityOverride | undefined => {
  if (!value) {
    return undefined;
  }
  return OVERRIDE_BY_URL_VALUE[value.toLowerCase()];
};

export const mapDisableHeaderHighlight = (
  value: string | null | undefined,
): boolean => value?.toLowerCase() === 'true';
